<template>
  <span v-if="!loading && count" class="my-space-hero-chip" title="Recordatorios vencidos y programados para hoy" @click="goReminders"><AppIcon name="alarm" />{{ count }} {{ count === 1 ? 'recordatorio pendiente' : 'recordatorios pendientes' }}</span>
</template>
<script>
import moment from 'moment'
import serviceReminders from '../staff/services'
import ErrorToken from '@/handler/errorToken'
import { EventBus } from '@/handler/event-bus'
export default {
  name: 'MySpaceRemindersSummaryWidget', data: () => ({ loading: true, count: 0 }),
  mounted() { EventBus.$on('MySpace:reminders-refresh', this.load); this.load() }, beforeDestroy() { EventBus.$off('MySpace:reminders-refresh', this.load) },
  methods: { load() { serviceReminders.obtenerReminders({ status: 'pending', date_end: moment().format('YYYY-MM-DD') }).then(response => { this.count = Array.isArray(response.data) ? response.data.length : 0; this.loading = false }).catch(error => { this.loading = false; this.$awn.alert(ErrorToken.valid(error)) }) }, goReminders() { this.$router.push({ name: 'RemindersStaffCrud' }).catch(() => {}) } },
}
</script>
